import { SEGMENT_EVENTS } from '~/constants/segmentAnalytics'

const twoFactorAuthStore = useTwoFactorAuthStore(),
  analyticsStore = useAnalyticsStore()

const twoFASetupEnabled = computed(() => twoFactorAuthStore.twoFactorAuthStatus !== 'SetupRequired')

const send2FASegment = (segmentName: string) => {
  analyticsStore.track({
    eventName: segmentName,
    properties: {
      location: useNavStore().currentFlow,
      setup2FAEnabled: twoFASetupEnabled.value,
      methodsAvailable: twoFactorAuthStore.phoneNumberIsLandline
        ? 'Landline'
        : twoFactorAuthStore.verificationChannels.join(','),
      accountType: useRegisterStore().segmentAccountType,
    },
  })
}
export const useLeave2FA = () => send2FASegment(SEGMENT_EVENTS.leaveRegistration.LEAVE_2FA)
export const useLeave2FAConfirmed = () =>
  send2FASegment(SEGMENT_EVENTS.leaveRegistration.LEAVE_2FA_CONFIRMED)
export const useLeave2FACancelled = () =>
  send2FASegment(SEGMENT_EVENTS.leaveRegistration.LEAVE_2FA_CANCELLED)
